import React from 'react';

const Container = (props) => {
  return (
    <div className='component:Container animated fadeIn' {...props}>
      {props.children}
    </div>
  );
};

export default Container;
